import React from "react"
import { createStackNavigator } from "@react-navigation/stack"
import {
  MemberScreen,
  PromotionDetailScreen,
  PromotionScreen,
  PointHistoryScreen,
  RedeemScreen,
} from "screens"
import { translate } from "i18n"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"

import { Header } from "components"

export type MemberParamList = {
  promotion: undefined
  promotionDetail: undefined
}
const Stack = createStackNavigator<MemberParamList>()

export const NewsStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        headerBackImage: () => <MaterialIcons name="chevron-left" color="white" size={42} />,
        header: (props) => {
          return <Header {...props} />
        },
        headerBackTitleVisible: false,
        headerTitleAlign: "left",
        headerStyle: {
          backgroundColor: "transparent",
          borderBottomWidth: 0,
        },
        headerTintColor: "white",
        cardStyle: { flex: 1 },
      }}
    >
      <Stack.Screen name="promotion" component={PromotionScreen} />
      <Stack.Screen
        name="promotionDetail"
        component={PromotionDetailScreen}
        options={{
          headerShown: false,
        }}
      />
    </Stack.Navigator>
  )
}
